/* Change this file to get your personal Portfolio */

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation";

const splashScreen = {
  enabled: true,
  animation: splashAnimation,
  duration: 2000
};

const illustration = {
  animated: true
};

const greeting = {
  username: "Nabilah Nordin",
  title: "Hi all, I'm Nabilah",
  subTitle: emoji(
    "A dedicated IT student specializing in Business Intelligence and Information Systems with hands-on experience in Full-Stack Development, Data Visualization, and Analytics."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1_m3MB0-ehFmK6ja_185WmuUxlAqSA33Q/view?usp=sharing",
  displayGreeting: true
};

const socialMediaLinks = {
  github: "https://github.com/NabilahNordin",
  gmail: "nabilahnord@gmail.com",
  whatsapp: "+6019-6511239",
  display: true
};

const skillsSection = {
  title: "What I do",
  subTitle: "FULL STACK DEVELOPER | DATA ANALYST | BUSINESS INTELLIGENCE SPECIALIST",
  skills: [
    "Develop scalable full-stack web applications using Laravel, PHP, and modern JavaScript frameworks",
    "Design and optimize data warehouses with dimensional modeling, ETL, and business intelligence solutions",
    "Create interactive dashboards and data visualizations using Power BI, Tableau, and Excel",
    "Implement secure authentication systems with role-based access control and advanced security measures"
  ],
  softwareSkills: [
    {skillName: "PHP", fontAwesomeClassname: "fab fa-php"},
    {skillName: "Laravel", fontAwesomeClassname: "fab fa-laravel"},
    {skillName: "MySQL", fontAwesomeClassname: "fas fa-database"},
    {skillName: "SQL Server", fontAwesomeClassname: "fas fa-database"},
    {skillName: "html-5", fontAwesomeClassname: "fab fa-html5"},
    {skillName: "css3", fontAwesomeClassname: "fab fa-css3-alt"},
    {skillName: "JavaScript", fontAwesomeClassname: "fab fa-js"},
    {skillName: "reactjs", fontAwesomeClassname: "fab fa-react"},
    {skillName: "R Programming", fontAwesomeClassname: "fab fa-r-project"},
    {skillName: "Python", fontAwesomeClassname: "fab fa-python"},
    {skillName: "Power BI", fontAwesomeClassname: "fas fa-chart-bar"},
    {skillName: "Tableau", fontAwesomeClassname: "fas fa-chart-pie"},
    {skillName: "Excel", fontAwesomeClassname: "fas fa-table"},
    {skillName: "WordPress", fontAwesomeClassname: "fab fa-wordpress"},
    {skillName: "GitHub", fontAwesomeClassname: "fab fa-github"},
    {skillName: "Figma", fontAwesomeClassname: "fab fa-figma"}
  ],
  display: true
};

const educationInfo = {
  display: true,
  title: "Education",
  subtitle: "Basic Qualification and Certifications",
  schools: [
    {
      schoolName: "International Islamic University Malaysia (IIUM)",
      logo: `${process.env.PUBLIC_URL}/iium.png`,
      icon: "fas fa-graduation-cap",
      subHeader: "Bachelor of Information and Communication Technology (Hons)",
      duration: "2023 - Expected Graduation 2027",
      desc: "Specialisation in Business Intelligence and Information Systems | CGPA: 3.71",
      descBullets: [
        "Dean's List Awards (all semesters)",
        "Published 3 research papers in recognized journals",
        "Best Presentation Award: INNOVATEX 2026"
      ]
    },
    {
      schoolName: "International Islamic University Malaysia (IIUM)",
      logo: `${process.env.PUBLIC_URL}/CFS.png`,
      icon: "fas fa-school",
      subHeader: "Foundation in Biological Science",
      duration: "2022",
      desc: "CGPA: 3.00",
      descBullets: ["Strong foundation in scientific and analytical thinking"]
    },
    {
      schoolName: "Tahfiz Certification Darul Quran JAKIM",
      logo: `${process.env.PUBLIC_URL}/DQ.jpg`,
      icon: "fas fa-book-open",
      subHeader: "Tahfiz Program",
      duration: "2021",
      desc: "CGPA: 3.43",
      descBullets: ["Completed Quranic memorization certification"]
    }
  ]
};

const techStack = {
  viewSkillBars: true,
  experience: [
    {Stack: "Full-Stack Development (Laravel/PHP)", progressPercentage: "85%"},
    {Stack: "Data Analytics and BI Tools", progressPercentage: "75%"},
    {Stack: "Database and ETL", progressPercentage: "75%"},
    {Stack: "Frontend (HTML/CSS/JS/React)", progressPercentage: "70%"},
    {Stack: "Data Science (R/Python/Excel)", progressPercentage: "65%"}
  ],
  displayCodersrank: false
};

const bigProjects = {
  title: "Projects",
  subtitle: "I enjoy working on projects that combine data analysis and design. From building dashboards and cleaning datasets to creating visuals and user-friendly interfaces, I've been able to apply both sides of my skill set.",
  projects: [
    {
      icon: "fas fa-heartbeat",
      projectName: "Student Well-being and Crisis System",
      projectMeta: "Built with Laravel, MySQL, RBAC",
      projectDesc:
        "Full-stack Laravel system for case tracking, user management, secure authentication, and role-based access control.",
      techStackIcons: ["fab fa-laravel", "fas fa-database", "fas fa-shield-alt"],
      footerLink: [
        {name: "View Project", url: "https://github.com/NabilahNordin/e-Tawasul"}
      ]
    },
    {
      icon: "fas fa-globe-asia",
      projectName: "Freelance Website Project",
      projectMeta: "WordPress delivery project",
      projectDesc:
        "Responsive WordPress website delivered end-to-end ahead of schedule.",
      techStackIcons: ["fab fa-wordpress", "fab fa-css3-alt", "fab fa-js"],
      footerLink: [
        {name: "Visit Website", url: "https://kulliyyah.iium.edu.my/kict/psc/"}
      ]
    },
    {
      icon: "fas fa-file-invoice-dollar",
      projectName: "Ninja Invoice System",
      projectMeta: "Business web app",
      projectDesc:
        "Business invoicing platform with recurring invoices, dashboard analytics, and scalable backend architecture.",
      techStackIcons: ["fab fa-php", "fas fa-database", "fas fa-chart-line"],
      footerLink: [
        {name: "GitHub", url: "https://github.com/NabilahNordin/invoice-web-app"}
      ]
    },
    {
      icon: "fas fa-database",
      projectName: "Data Warehouse Project",
      projectMeta: "ETL + dimensional modeling",
      projectDesc:
        "Star-schema data warehouse with ETL flows and reporting integration.",
      techStackIcons: ["fas fa-database", "fas fa-exchange-alt", "fas fa-chart-pie"],
      footerLink: [
        {
          name: "Documentation",
          url: "https://drive.google.com/file/d/1veDF7NjcZDJwS-WfNBO-2B2OV3gNv4QG/view?usp=sharing"
        }
      ]
    },
    {
      icon: "fas fa-search",
      projectName: "Data Mining Research",
      projectMeta: "R + Excel analytics study",
      projectDesc:
        "Data mining and pattern analysis on student extracurricular factors using R and Excel.",
      techStackIcons: ["fab fa-r-project", "fas fa-table", "fas fa-brain"],
      footerLink: [
        {
          name: "Documentation",
          url: "https://drive.google.com/file/d/1OidlmeZZMEsZnrLuUVNKq3nJfPe1qhi8/view?usp=sharing"
        }
      ]
    },
    {
      icon: "fas fa-user-shield",
      projectName: "Security Layer Implementation",
      projectMeta: "2FA and access hardening",
      projectDesc:
        "Authentication, authorization, and security hardening with 2FA and access-control improvements.",
      techStackIcons: ["fas fa-lock", "fas fa-fingerprint", "fas fa-user-check"],
      footerLink: [
        {
          name: "GitHub",
          url: "https://github.com/amyshaqistina/invoice-web-security"
        }
      ]
    },
    {
      icon: "fas fa-chart-bar",
      projectName: "Digital Behaviour and Learning Effectiveness (Tableau)",
      projectMeta: "Interactive BI storytelling",
      projectDesc:
        "Interactive Tableau storytelling dashboards analyzing digital behavior and student learning effectiveness.",
      techStackIcons: ["fas fa-chart-bar", "fas fa-lightbulb", "fas fa-graduation-cap"],
      footerLink: [
        {
          name: "Tableau",
          url: "https://public.tableau.com/app/profile/nabilah.ahmad.nordin/viz/G1Real/Storyboard?publish=yes"
        }
      ]
    },
    {
      icon: "fas fa-pencil-ruler",
      projectName: "Goodreads UI Improvement",
      projectMeta: "Frontend usability redesign",
      projectDesc:
        "UI enhancement project using HTML, CSS, and JavaScript to improve usability and visual experience.",
      techStackIcons: ["fab fa-html5", "fab fa-css3-alt", "fab fa-js"],
      footerLink: [
        {
          name: "Documentation",
          url: "https://drive.google.com/file/d/1SnGIctVATVavIL_VG0W1hh1ywoCgzerF/view?usp=sharing"
        }
      ]
    }
  ],
  display: true
};

const MajorProjects = bigProjects;

const achievementSection = {
  title: "Awards",
  subtitle:
    "Achievements, certifications, and milestones from my academic and project journey",
  achievementsCards: [
    {
      title: "CCNA v7: Introduction to Networks",
      subtitle:
        "Cisco Certified Network Associate certification demonstrating core networking knowledge.",
      icon: "fas fa-network-wired",
      iconColor: "#0b3a84",
      imageAlt: "Cisco CCNA Certification",
      footerLink: []
    },
    {
      title: "Dean's List Awards",
      subtitle:
        "Recognized for academic excellence across all semesters at IIUM.",
      icon: "fas fa-medal",
      iconColor: "#f59f00",
      imageAlt: "Dean's List Award",
      footerLink: []
    },
    {
      title: "Best Presentation Award - INNOVATEX 2026",
      subtitle:
        "Won best presentation for Final Year Project competition.",
      icon: "fas fa-trophy",
      iconColor: "#e67e22",
      imageAlt: "INNOVATEX Award",
      footerLink: []
    },
    {
      title: "Published Research Papers",
      subtitle: "Authored and published 3 research papers.",
      subtitleLink: "https://drive.google.com/drive/folders/1F1PGf0iveybZ-RZlu3B-2X5omRPl6faK?usp=sharing",
      icon: "fas fa-scroll",
      iconColor: "#2d74b8",
      imageAlt: "Research Publication",
      footerLink: []
    }
  ],
  display: true
};

const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to read my resume",
  display: false
};

const contactInfo = {
  title: "Contact Me",
  subtitle: "If you are looking for an intern, please feel free to contact me.",
  number: "+6019-6511239",
  email_address: "nabilahnord@gmail.com",
  resumeLink: greeting.resumeLink,
  resumeText: "See my resume",
  coverLetterLink:
    "https://drive.google.com/file/d/123Pnib6xvlIw1yK5UDhivR9xwRj3ZTMi/view?usp=sharing",
  coverLetterText: "SEE MY COVER LETTER"
};

const isHireable = true;

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  bigProjects,
  MajorProjects,
  achievementSection,
  contactInfo,
  isHireable,
  resumeSection
};
